const fragment = `
  id
  permission
  user {
    id
    name
    email
  }
  team {
    id
    name
  }
`;

export const listTeamUsersQuery = `
  query ListTeamUsers(
    $filter: TeamUserFilterInput
  ) {
    items: listTeamUsers(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getTeamUserQuery = `
  query GetTeamUser($id: Int!) {
    item: getTeamUser(id: $id) {
      ${fragment}
    }
  }
`;

export const createTeamUserQuery = `
  mutation CreateTeamUser(
    $input: CreateTeamUserInput!
  ) {
    item: createTeamUser(input: $input) {
      ${fragment}
    }
  }
`;

export const updateTeamUserQuery = `
  mutation UpdateTeamUser(
    $input: UpdateTeamUserInput!
  ) {
    item: updateTeamUser(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteTeamUserQuery = `
  mutation DeleteTeamUser(
    $id: Int!
  ) {
    item: deleteTeamUser(id: $id) {
      ${fragment}
    }
  }
`;
